import { localize } from '../../nls.js';
const minute = 60;
const hour = minute * 60;
const day = hour * 24;
const week = day * 7;
const month = day * 30;
const year = day * 365;
function fromNow(date, appendAgoLabel, useFullTimeWords, disallowNow) {
    if (typeof date !== 'number') {
        date = date.getTime();
    }
    const seconds = Math.round((( (new Date())).getTime() - date) / 1000);
    if (seconds < -30) {
        return ( localize(
            793,
            'in {0}',
            fromNow(( (new Date())).getTime() + seconds * 1000, false)
        ));
    }
    if (!disallowNow && seconds < 30) {
        return ( localize(794, 'now'));
    }
    let value;
    if (seconds < minute) {
        value = seconds;
        if (appendAgoLabel) {
            if (value === 1) {
                return useFullTimeWords
                    ? ( localize(795, '{0} second ago', value))
                    : ( localize(796, '{0} sec ago', value));
            }
            else {
                return useFullTimeWords
                    ? ( localize(797, '{0} seconds ago', value))
                    : ( localize(798, '{0} secs ago', value));
            }
        }
        else {
            if (value === 1) {
                return useFullTimeWords
                    ? ( localize(799, '{0} second', value))
                    : ( localize(800, '{0} sec', value));
            }
            else {
                return useFullTimeWords
                    ? ( localize(801, '{0} seconds', value))
                    : ( localize(802, '{0} secs', value));
            }
        }
    }
    if (seconds < hour) {
        value = Math.floor(seconds / minute);
        if (appendAgoLabel) {
            if (value === 1) {
                return useFullTimeWords
                    ? ( localize(803, '{0} minute ago', value))
                    : ( localize(804, '{0} min ago', value));
            }
            else {
                return useFullTimeWords
                    ? ( localize(805, '{0} minutes ago', value))
                    : ( localize(806, '{0} mins ago', value));
            }
        }
        else {
            if (value === 1) {
                return useFullTimeWords
                    ? ( localize(807, '{0} minute', value))
                    : ( localize(808, '{0} min', value));
            }
            else {
                return useFullTimeWords
                    ? ( localize(809, '{0} minutes', value))
                    : ( localize(810, '{0} mins', value));
            }
        }
    }
    if (seconds < day) {
        value = Math.floor(seconds / hour);
        if (appendAgoLabel) {
            if (value === 1) {
                return useFullTimeWords
                    ? ( localize(811, '{0} hour ago', value))
                    : ( localize(812, '{0} hr ago', value));
            }
            else {
                return useFullTimeWords
                    ? ( localize(813, '{0} hours ago', value))
                    : ( localize(814, '{0} hrs ago', value));
            }
        }
        else {
            if (value === 1) {
                return useFullTimeWords
                    ? ( localize(815, '{0} hour', value))
                    : ( localize(816, '{0} hr', value));
            }
            else {
                return useFullTimeWords
                    ? ( localize(817, '{0} hours', value))
                    : ( localize(818, '{0} hrs', value));
            }
        }
    }
    if (seconds < week) {
        value = Math.floor(seconds / day);
        if (appendAgoLabel) {
            return value === 1
                ? ( localize(819, '{0} day ago', value))
                : ( localize(820, '{0} days ago', value));
        }
        else {
            return value === 1
                ? ( localize(821, '{0} day', value))
                : ( localize(822, '{0} days', value));
        }
    }
    if (seconds < month) {
        value = Math.floor(seconds / week);
        if (appendAgoLabel) {
            if (value === 1) {
                return useFullTimeWords
                    ? ( localize(823, '{0} week ago', value))
                    : ( localize(824, '{0} wk ago', value));
            }
            else {
                return useFullTimeWords
                    ? ( localize(825, '{0} weeks ago', value))
                    : ( localize(826, '{0} wks ago', value));
            }
        }
        else {
            if (value === 1) {
                return useFullTimeWords
                    ? ( localize(827, '{0} week', value))
                    : ( localize(828, '{0} wk', value));
            }
            else {
                return useFullTimeWords
                    ? ( localize(829, '{0} weeks', value))
                    : ( localize(830, '{0} wks', value));
            }
        }
    }
    if (seconds < year) {
        value = Math.floor(seconds / month);
        if (appendAgoLabel) {
            if (value === 1) {
                return useFullTimeWords
                    ? ( localize(831, '{0} month ago', value))
                    : ( localize(832, '{0} mo ago', value));
            }
            else {
                return useFullTimeWords
                    ? ( localize(833, '{0} months ago', value))
                    : ( localize(834, '{0} mos ago', value));
            }
        }
        else {
            if (value === 1) {
                return useFullTimeWords
                    ? ( localize(835, '{0} month', value))
                    : ( localize(836, '{0} mo', value));
            }
            else {
                return useFullTimeWords
                    ? ( localize(837, '{0} months', value))
                    : ( localize(838, '{0} mos', value));
            }
        }
    }
    value = Math.floor(seconds / year);
    if (appendAgoLabel) {
        if (value === 1) {
            return useFullTimeWords
                ? ( localize(839, '{0} year ago', value))
                : ( localize(840, '{0} yr ago', value));
        }
        else {
            return useFullTimeWords
                ? ( localize(841, '{0} years ago', value))
                : ( localize(842, '{0} yrs ago', value));
        }
    }
    else {
        if (value === 1) {
            return useFullTimeWords
                ? ( localize(843, '{0} year', value))
                : ( localize(844, '{0} yr', value));
        }
        else {
            return useFullTimeWords
                ? ( localize(845, '{0} years', value))
                : ( localize(846, '{0} yrs', value));
        }
    }
}
function getDurationString(ms, useFullTimeWords) {
    const seconds = Math.abs(ms / 1000);
    if (seconds < 1) {
        return ( localize(848, '{0}ms', ms));
    }
    if (seconds < minute) {
        return ( localize(850, '{0}s', Math.round(ms) / 1000));
    }
    if (seconds < hour) {
        return ( localize(852, '{0} mins', Math.round(ms / (1000 * minute))));
    }
    if (seconds < day) {
        return ( localize(854, '{0} hrs', Math.round(ms / (1000 * hour))));
    }
    return ( localize(855, '{0} days', Math.round(ms / (1000 * day))));
}
function toLocalISOString(date) {
    return date.getFullYear() +
        '-' + String(date.getMonth() + 1).padStart(2, '0') +
        '-' + String(date.getDate()).padStart(2, '0') +
        'T' + String(date.getHours()).padStart(2, '0') +
        ':' + String(date.getMinutes()).padStart(2, '0') +
        ':' + String(date.getSeconds()).padStart(2, '0') +
        '.' + (date.getMilliseconds() / 1000).toFixed(3).slice(2, 5) +
        'Z';
}
export { fromNow, getDurationString, toLocalISOString };
